// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-formation-modal .modal2.medium .modal2__container{
    width: auto;
}

.formation-field__line-up,.formation-field__line-up-list {
    display: flex;
    align-items: center;
    margin-left: var( --space );
    margin-top: var( --space-x2 );
}

.formation-field__line-up label {
    color: var( --primary-dark-color );
    margin-right: var( --space );
}

.formation-field__select select {
    outline: none;
    border: none;
    padding-right: var( --space-x2 );
    background: var( --disabled-sb-bg-color );
}

.formation-field__select {
    border-radius: var( --space-half );
    background: var( --new-input-background-color );
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: normal;
    font-size: calc( var( --space ) + 1px );
    line-height: calc( var( --space ) + var( --space-quarter ) );
    display: flex;
    align-items: center;
    letter-spacing: 0.0025em;
    color: var( --primary-very-dark-color );
    padding: calc( var( --space-half-quarter ) + var(--space-eighth ) ) var( --space );
}



.formation-field__container {
    display: flex;
}

.formation-field__col {
    /* width: 50%; */
    padding-right: var( --space-and-half );
}

.formation-field__row {
    display: flex;
    justify-content: space-evenly;
    width: 100%;
}

.formation-field__row__unassigned__container {
    min-height: 62px;
    min-width: 62px;
    max-height: 62px;
    max-width: 62px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 50%;
    box-shadow: var( --shadow-card-1 );
    background: var(--white-color);
    justify-content: center;
    cursor: pointer;
}

.formation-field__row__unassigned__container .formation-field__username {
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: bold;
    font-size: var( --space-half-quarter );
    line-height: calc( var( --space ) + var( --space-eighth ) );
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.04em;
    text-transform: capitalize;
    color: var( --primary-dark-color );
}

.formation-field__row__assigned__container {
    display: flex;
    cursor: pointer;
}

.formation-field__row__assigned__container span {
     font-size: 0.5vw; /*0.41vw == 8px*/
}

.formation-field__row__unassigned__container.selected-field {
    background: var( --primary-dark-color );
}

.formation-field__row__unassigned__container.selected-field span {
    color: var( --white-color );
    font-size: calc( var( --space-half ) + var( --space-quarter));
}

 .selected-field .formation-field__row__img path {
    fill: var( --white-color );
}

.formation-field__username.baloa-username {
    color: var( --primary-dark-color );
}

.formation-field__username.baloa-truncate {
    width: calc( var( --space-x3 ) + var( --space-quarter ) );
    text-align: center;
}

.formation-field__row__img {
    width: var(--space-and-half);
    height: var(--space-and-half);
}

.formation-field, .formation-field-right  {
    position: relative;
}

.formation-field__container__line-up {
    width: 360px;
    position: absolute;
    /* right: 0; */
    height: 543px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
}

.display-form-players{
    display: flex;
}

.display-form-players {
    margin-top: var(--space-x2);
}

.display-form-players img {
    width: calc(var(--space-x2) + var(--space-half));
}

.display-form-players .button-position-selected {
    border: 2px solid var( --secondary-color );
    align-content: center;
    background: transparent;
    box-shadow: none;
    text-align: center;
    cursor: pointer;
    margin-right: calc( var( --space-x2 ) - var( --space-half ) ) ;
    position: absolute;
    right: 0;
    font-family: var( --secondary-font );
    font-style: normal;
    font-weight: bold;
    font-size: var( --space-half-quarter );
    line-height: var( --space );
    letter-spacing: 0.04em;
}

.formation-field__erase-field.icon-x {
    position: fixed;
    background: var( --new-gray-background-color );
    border-radius: 50%;
    font-size: calc( var( --space ) + var( --space-eighth ) + 1px );
    color: var( --primary-dark-color );
    margin-left: calc( var( --space-x3 ) + var( --space-quarter ) );
    margin-top: -12px
}

svg.formation-field__erase-field path{
    fill: var(--secondary-light-color) !important;
}

.info-formation {
    text-align: center;
    margin-top: var(--space-x3);
}

.info-formation svg {
    width: var( --space-x3 );
    height: var( --space-x3 );
}

.info-formation svg path {
    fill: var(--mid-gray-color);
}

.info-formation h5 {
    margin-top: calc(var(--space) + var(--space-quarter));
    color: var(--mid-gray-color) !important;
}

.formation-field__col-right .input-search__input div {
    box-shadow: none;
    border-radius: 2px;
    padding: var( --space-half ) var( --space );
}

.formation-field__col-right .input-search__input {
    background: transparent;
    border: 2px solid var(--primary-light-color);
}

.selected-user {
    margin-left: var( --space-half );
}

.formation-field__username__container {
    background: var( --white-color );
    border-radius: var( --space-half );
    display: flex;
    align-items: center;
    padding: 2px 4px;
    margin-top: var( --space-half );
}

.formation-field__searched-list {
    max-height: 400px;
}

.formation-field__col-right .input-with-button {
    border: 2px solid var(--primary-light-color);
}

.formation-field__container__img {
    display: flex;
    justify-content: flex-end;
    margin-top: var( --space-half-quarter );
}

.formation-field__container__img img {
    width: 360px;
}

.formation-field__input-player__container {
    position: absolute;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    z-index: 1;
    padding-right: var( --space-and-half );
    top: 170px;
}

.formation-field__input-player__container .input-with-button {
    background: var( --white-color );
    height: calc( var( --space-x3 ) + var( --space-and-half ) + var( --space-quarter ) + var( --space-eighth ) );
    align-items: center;
    gap: var( --space );
}

.formation-field__input-player__container .input-with-button textarea {
    background: var( --new-input-background-color );
    margin: var( --space ) 0 var( --space ) var( --space );
    padding: calc( var( --space-half-quarter ) + var( --space-eighth ) ) 0 0 var( --space-half-quarter );
    height: var( --space-x3 );
    border-radius: var( --space-half );
    width: 293px;
}

.formation-field__input-player__container .input-with-button__button.baloa-username {
    display: flex;
    align-items: center;
    text-align: center;
    font-weight: var(--font-bold);
    color: var(--new-green-color);
    background: none;
    outline: none;
    border-radius: calc( var( --space-quarter ) + var( --space-eighth ) );
    border: 2px solid var( --new-green-color );
    height: calc( var( --space-x2 ) + var( --space-half ) );
    width: 144px;
    justify-content: center;
    margin-right: var( --space );
}

.formation-field__row__assigned__container .icon-ball {
    font-size: 50px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 6px;
    color: var(--white-color);
}

.formation-field__input-player {
    background-color: var( --white-color );
    border-radius: var( --space-half );
    box-shadow: 0px 5px 16px 5px rgba(0, 0, 0, 0.25);
}

.formation-field__input-error {
    margin-left: var( --space );
}

.formation-field__input-error.baloa-username {
    font-size: var( --space-half-quarter );
    color: var(--error-color);
    margin-top: -8px;
    margin-bottom: var( --space-half );
}

.formation-field__row__assigned {
    display: flex;
    flex-direction: column;
    align-items: center;
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {

    /* .formation-field__row__striker {
        margin-bottom: 12%;
    }
    .formation-field__row__midfielder {
        margin-bottom: 10%;
    }
    .formation-field__row__defender {
        margin-bottom: 3%;
    }
    .formation-field__row__goalkeeper {
        padding-top: 3%;
    }     */
}

@media only screen and (min-width: 1024px) and (max-width: 1439px) {

    /* .formation-field__row__striker {
        margin-bottom: 12%;
    }
    .formation-field__row__midfielder {
        margin-bottom: 10%;
    }
    .formation-field__row__defender {
        margin-bottom: 3%;
    }
    .formation-field__row__goalkeeper {
        padding-top: 3%;
    }     */
}

@media only screen and (min-width: 1440px) and (max-width: 1600px) {

    /* .formation-field__row__striker {
        margin-bottom: 25%;
    }
    .formation-field__row__midfielder {
        margin-bottom: 14%;
    }
    .formation-field__row__defender {
        margin-bottom: 6%;
    }             */
}

@media only screen and (min-width: 1601px) {

    /* .formation-field__row__striker {
        margin-bottom: 18%;
    }
    .formation-field__row__midfielder {
        margin-bottom: 14%;
    }
    .formation-field__row__defender {
        margin-bottom: 6%;
    }     */
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */


    .formation-field__line-up {
        display: flex;
        position: absolute;

    }
    .formation-field-right{
        margin-bottom: 30%;
        margin-top: 10%;
    }

    .formation-field__container__line-up, .formation-field__container__img img {
        width: 100%;
        top: 60px;
        height: 500px;
    }

    .formation-field__col{
        padding-right: calc( var(--space) * 2 );
    }

    .formation-field__row__unassigned__container{
        min-height: 52px;
        min-width: 52px;
        max-height: 52px;
        max-width: 52px;
    }

    /* .formation-field__input-player__container{
        margin-left: 6%;
    } */

    .formation-field__input-player__container .input-with-button textarea{
        width: 230px;
    }

    .formation-field__input-player__container .input-with-button__button.baloa-username{
        width: 80px;
    }
}`, "",{"version":3,"sources":["webpack://./src/shared/components/formation/FormationFieldComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gCAAgC;IAChC,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,+CAA+C;IAC/C,oCAAoC;IACpC,kBAAkB;IAClB,mBAAmB;IACnB,uCAAuC;IACvC,4DAA4D;IAC5D,aAAa;IACb,mBAAmB;IACnB,wBAAwB;IACxB,uCAAuC;IACvC,kFAAkF;AACtF;;;;AAIA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;IACtC,2DAA2D;IAC3D,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;KACK,gBAAgB,EAAE,gBAAgB;AACvC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,2BAA2B;IAC3B,6DAA6D;AACjE;;CAEC;IACG,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,yDAAyD;IACzD,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,0CAA0C;IAC1C,qBAAqB;IACrB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,8DAA8D;IAC9D,kBAAkB;IAClB,QAAQ;IACR,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,sCAAsC;IACtC,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,8CAA8C;IAC9C,kBAAkB;IAClB,+DAA+D;IAC/D,kCAAkC;IAClC,+DAA+D;IAC/D;AACJ;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qDAAqD;IACrD,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,uBAAuB;IACvB,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,UAAU;IACV,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,4GAA4G;IAC5G,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,+CAA+C;IAC/C,sDAAsD;IACtD,oGAAoG;IACpG,yBAAyB;IACzB,kCAAkC;IAClC,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,6BAA6B;IAC7B,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,qEAAqE;IACrE,0CAA0C;IAC1C,uDAAuD;IACvD,YAAY;IACZ,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,sCAAsC;IACtC,kCAAkC;IAClC,gDAAgD;AACpD;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,yBAAyB;IACzB,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;;IAEI;;;;;;;;;;;WAWO;AACX;;AAEA;;IAEI;;;;;;;;;;;WAWO;AACX;;AAEA;;IAEI;;;;;;;;mBAQe;AACnB;;AAEA;;IAEI;;;;;;;;WAQO;AACX;;AAEA,yCAAyC,4BAA4B;;;IAGjE;QACI,aAAa;QACb,kBAAkB;;IAEtB;IACA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,eAAe;IACnB;;IAEA;;OAEG;;IAEH;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".create-formation-modal .modal2.medium .modal2__container{\n    width: auto;\n}\n\n.formation-field__line-up,.formation-field__line-up-list {\n    display: flex;\n    align-items: center;\n    margin-left: var( --space );\n    margin-top: var( --space-x2 );\n}\n\n.formation-field__line-up label {\n    color: var( --primary-dark-color );\n    margin-right: var( --space );\n}\n\n.formation-field__select select {\n    outline: none;\n    border: none;\n    padding-right: var( --space-x2 );\n    background: var( --disabled-sb-bg-color );\n}\n\n.formation-field__select {\n    border-radius: var( --space-half );\n    background: var( --new-input-background-color );\n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: normal;\n    font-size: calc( var( --space ) + 1px );\n    line-height: calc( var( --space ) + var( --space-quarter ) );\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.0025em;\n    color: var( --primary-very-dark-color );\n    padding: calc( var( --space-half-quarter ) + var(--space-eighth ) ) var( --space );\n}\n\n\n\n.formation-field__container {\n    display: flex;\n}\n\n.formation-field__col {\n    /* width: 50%; */\n    padding-right: var( --space-and-half );\n}\n\n.formation-field__row {\n    display: flex;\n    justify-content: space-evenly;\n    width: 100%;\n}\n\n.formation-field__row__unassigned__container {\n    min-height: 62px;\n    min-width: 62px;\n    max-height: 62px;\n    max-width: 62px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    border-radius: 50%;\n    box-shadow: var( --shadow-card-1 );\n    background: var(--white-color);\n    justify-content: center;\n    cursor: pointer;\n}\n\n.formation-field__row__unassigned__container .formation-field__username {\n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: bold;\n    font-size: var( --space-half-quarter );\n    line-height: calc( var( --space ) + var( --space-eighth ) );\n    display: flex;\n    align-items: center;\n    text-align: center;\n    letter-spacing: 0.04em;\n    text-transform: capitalize;\n    color: var( --primary-dark-color );\n}\n\n.formation-field__row__assigned__container {\n    display: flex;\n    cursor: pointer;\n}\n\n.formation-field__row__assigned__container span {\n     font-size: 0.5vw; /*0.41vw == 8px*/\n}\n\n.formation-field__row__unassigned__container.selected-field {\n    background: var( --primary-dark-color );\n}\n\n.formation-field__row__unassigned__container.selected-field span {\n    color: var( --white-color );\n    font-size: calc( var( --space-half ) + var( --space-quarter));\n}\n\n .selected-field .formation-field__row__img path {\n    fill: var( --white-color );\n}\n\n.formation-field__username.baloa-username {\n    color: var( --primary-dark-color );\n}\n\n.formation-field__username.baloa-truncate {\n    width: calc( var( --space-x3 ) + var( --space-quarter ) );\n    text-align: center;\n}\n\n.formation-field__row__img {\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n}\n\n.formation-field, .formation-field-right  {\n    position: relative;\n}\n\n.formation-field__container__line-up {\n    width: 360px;\n    position: absolute;\n    /* right: 0; */\n    height: 543px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-evenly;\n}\n\n.display-form-players{\n    display: flex;\n}\n\n.display-form-players {\n    margin-top: var(--space-x2);\n}\n\n.display-form-players img {\n    width: calc(var(--space-x2) + var(--space-half));\n}\n\n.display-form-players .button-position-selected {\n    border: 2px solid var( --secondary-color );\n    align-content: center;\n    background: transparent;\n    box-shadow: none;\n    text-align: center;\n    cursor: pointer;\n    margin-right: calc( var( --space-x2 ) - var( --space-half ) ) ;\n    position: absolute;\n    right: 0;\n    font-family: var( --secondary-font );\n    font-style: normal;\n    font-weight: bold;\n    font-size: var( --space-half-quarter );\n    line-height: var( --space );\n    letter-spacing: 0.04em;\n}\n\n.formation-field__erase-field.icon-x {\n    position: fixed;\n    background: var( --new-gray-background-color );\n    border-radius: 50%;\n    font-size: calc( var( --space ) + var( --space-eighth ) + 1px );\n    color: var( --primary-dark-color );\n    margin-left: calc( var( --space-x3 ) + var( --space-quarter ) );\n    margin-top: -12px\n}\n\nsvg.formation-field__erase-field path{\n    fill: var(--secondary-light-color) !important;\n}\n\n.info-formation {\n    text-align: center;\n    margin-top: var(--space-x3);\n}\n\n.info-formation svg {\n    width: var( --space-x3 );\n    height: var( --space-x3 );\n}\n\n.info-formation svg path {\n    fill: var(--mid-gray-color);\n}\n\n.info-formation h5 {\n    margin-top: calc(var(--space) + var(--space-quarter));\n    color: var(--mid-gray-color) !important;\n}\n\n.formation-field__col-right .input-search__input div {\n    box-shadow: none;\n    border-radius: 2px;\n    padding: var( --space-half ) var( --space );\n}\n\n.formation-field__col-right .input-search__input {\n    background: transparent;\n    border: 2px solid var(--primary-light-color);\n}\n\n.selected-user {\n    margin-left: var( --space-half );\n}\n\n.formation-field__username__container {\n    background: var( --white-color );\n    border-radius: var( --space-half );\n    display: flex;\n    align-items: center;\n    padding: 2px 4px;\n    margin-top: var( --space-half );\n}\n\n.formation-field__searched-list {\n    max-height: 400px;\n}\n\n.formation-field__col-right .input-with-button {\n    border: 2px solid var(--primary-light-color);\n}\n\n.formation-field__container__img {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: var( --space-half-quarter );\n}\n\n.formation-field__container__img img {\n    width: 360px;\n}\n\n.formation-field__input-player__container {\n    position: absolute;\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n    z-index: 1;\n    padding-right: var( --space-and-half );\n    top: 170px;\n}\n\n.formation-field__input-player__container .input-with-button {\n    background: var( --white-color );\n    height: calc( var( --space-x3 ) + var( --space-and-half ) + var( --space-quarter ) + var( --space-eighth ) );\n    align-items: center;\n    gap: var( --space );\n}\n\n.formation-field__input-player__container .input-with-button textarea {\n    background: var( --new-input-background-color );\n    margin: var( --space ) 0 var( --space ) var( --space );\n    padding: calc( var( --space-half-quarter ) + var( --space-eighth ) ) 0 0 var( --space-half-quarter );\n    height: var( --space-x3 );\n    border-radius: var( --space-half );\n    width: 293px;\n}\n\n.formation-field__input-player__container .input-with-button__button.baloa-username {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    font-weight: var(--font-bold);\n    color: var(--new-green-color);\n    background: none;\n    outline: none;\n    border-radius: calc( var( --space-quarter ) + var( --space-eighth ) );\n    border: 2px solid var( --new-green-color );\n    height: calc( var( --space-x2 ) + var( --space-half ) );\n    width: 144px;\n    justify-content: center;\n    margin-right: var( --space );\n}\n\n.formation-field__row__assigned__container .icon-ball {\n    font-size: 50px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 6px;\n    color: var(--white-color);\n}\n\n.formation-field__input-player {\n    background-color: var( --white-color );\n    border-radius: var( --space-half );\n    box-shadow: 0px 5px 16px 5px rgba(0, 0, 0, 0.25);\n}\n\n.formation-field__input-error {\n    margin-left: var( --space );\n}\n\n.formation-field__input-error.baloa-username {\n    font-size: var( --space-half-quarter );\n    color: var(--error-color);\n    margin-top: -8px;\n    margin-bottom: var( --space-half );\n}\n\n.formation-field__row__assigned {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n@media only screen and (min-width: 768px) and (max-width: 1023px) {\n\n    /* .formation-field__row__striker {\n        margin-bottom: 12%;\n    }\n    .formation-field__row__midfielder {\n        margin-bottom: 10%;\n    }\n    .formation-field__row__defender {\n        margin-bottom: 3%;\n    }\n    .formation-field__row__goalkeeper {\n        padding-top: 3%;\n    }     */\n}\n\n@media only screen and (min-width: 1024px) and (max-width: 1439px) {\n\n    /* .formation-field__row__striker {\n        margin-bottom: 12%;\n    }\n    .formation-field__row__midfielder {\n        margin-bottom: 10%;\n    }\n    .formation-field__row__defender {\n        margin-bottom: 3%;\n    }\n    .formation-field__row__goalkeeper {\n        padding-top: 3%;\n    }     */\n}\n\n@media only screen and (min-width: 1440px) and (max-width: 1600px) {\n\n    /* .formation-field__row__striker {\n        margin-bottom: 25%;\n    }\n    .formation-field__row__midfielder {\n        margin-bottom: 14%;\n    }\n    .formation-field__row__defender {\n        margin-bottom: 6%;\n    }             */\n}\n\n@media only screen and (min-width: 1601px) {\n\n    /* .formation-field__row__striker {\n        margin-bottom: 18%;\n    }\n    .formation-field__row__midfielder {\n        margin-bottom: 14%;\n    }\n    .formation-field__row__defender {\n        margin-bottom: 6%;\n    }     */\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n\n    .formation-field__line-up {\n        display: flex;\n        position: absolute;\n\n    }\n    .formation-field-right{\n        margin-bottom: 30%;\n        margin-top: 10%;\n    }\n\n    .formation-field__container__line-up, .formation-field__container__img img {\n        width: 100%;\n        top: 60px;\n        height: 500px;\n    }\n\n    .formation-field__col{\n        padding-right: calc( var(--space) * 2 );\n    }\n\n    .formation-field__row__unassigned__container{\n        min-height: 52px;\n        min-width: 52px;\n        max-height: 52px;\n        max-width: 52px;\n    }\n\n    /* .formation-field__input-player__container{\n        margin-left: 6%;\n    } */\n\n    .formation-field__input-player__container .input-with-button textarea{\n        width: 230px;\n    }\n\n    .formation-field__input-player__container .input-with-button__button.baloa-username{\n        width: 80px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
